module.exports = __webpack_public_path__ + "img/department_icon.1a53293d.svg";